<script>
    import * as d3 from "d3";
    import { onMount, createEventDispatcher } from "svelte";
    import download from "downloadjs";

    export let D;
    export let computing;
	const dispatch = createEventDispatcher();

    let W = 24;
    let h = 24;
    let hm = 3;
    let H = 8 * (h + hm);
    let wm = 3;
    let m = 25;
    let ch = 5;
    let margin = {
        top: 50 + (8 * ch) + wm,
        top2: 55,
        left: 80,
        bottom: 65,
        right: 30,
    };


    let C = d3.scaleSequential(d3.interpolateReds)
        //.domain([0, d3.max(D.flat().flat().map(d => d.dur).flat(), d => d[2] - d[0])]);
        .domain([0, 10000]);

    let c = (x) => x < 100 ? "lightslategray" : x > 10000 ? "url(#none)" : C(x);
    let lc = (lib) => {
        return {
            "druid": "mediumseagreen",
            "sklearn": "orange",
            "js": "slateblue",
            "dr_sk": "url(#dr_sk)",
            "dr_js": "url(#dr_js)",
            "sk_js": "url(#sk_js)",
            "none": "url(#none)",
        }[lib];
    }

    let svgs = []
    const steps = 20;
    const lim = 6000;


    function download_svgs() {
        let nest = d3.nest().key(d => d.DR).entries(D);
        for (let i = 0; i < nest.length; ++i) {
            let filename = `eval_${nest[i].key}.svg`
            download(svgs[i].outerHTML, filename);
        }
    }

    function winner(dr, sk, js, d, n) {
        //console.log(dr, sk, js, d, n)
        let values = [dr, sk, js]
            .filter(D => D) // remove not existing
            .map(D => { // select d and n
                //console.log(D)
                if (D.length < d) return undefined;
                const row = D[d].filter(d => d)
                if (row.length <= n) return undefined;
                const col = row[n];
                return col.dur.map(d => [d[2] - d[0], D.LIB.slice(0, 2)]);
            })
            .filter(D => D) // remoove undefineds
            .flat()
            .filter(d => d[0] < 10000)

        if (values.length == 0) return "none"
        let [f, s, ...rest] = values
            //.filter(d => d[0] > 10000)
            .sort((a, b) => d3.ascending(a[0] || null, b[0] || null));
        switch (f[1] + s[1]) {
            case "sksk": return "sklearn";
            case "skdr":
            case "drsk":
                return "dr_sk";
            case "drdr": return "druid";
            case "drjs":
            case "jsdr":
                return "dr_js";
            case "jsjs": return "js";
            case "skjs":
            case "jssk":
                return "sk_js";
            default: return "none";
        }
    }
</script>

{#each d3.nest().key(d => d.DR).entries(D) as d, i}
    <svg bind:this={svgs[i]} width={margin.left + 31 * (W + wm) + margin.right} height={margin.top + d.values.length * (H + m) + margin.bottom}>
        <defs>
            <pattern id="none"
                x="0" y="0" width="6.356382351524142" height="6.356382351524142"
                patternUnits="userSpaceOnUse">
                <path
                    style="stroke:#333;stroke-width:1px"
                    d="M 2.5768547924690237,-3.7795275590551185 10.135909910579262,3.7795275590551185"/>
                <path
                    style="stroke:#333;stroke-width:1px"
                    d="M -3.7795275590551185,-3.7795275590551185 10.135909910579262,10.135909910579262"/>
                <path
                    style="stroke:#333;stroke-width:1px"
                    d="M -3.7795275590551185,2.5768547924690237 3.7795275590551185,10.135909910579262"/>
            </pattern>
            <marker id="arrow" markerWidth="10" markerHeight="10" refX="0" refY="3" orient="auto" markerUnits="strokeWidth">
                <path d="M0,0 L0,6 L9,3 z" fill="#000" />
            </marker>
            <pattern id="dr_sk" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(-45)">
                <line x1="0" y="0" x2="0" y2="6" stroke={lc("sklearn")} stroke-width="6" />
                <line x1="6" y="0" x2="6" y2="6" stroke={lc("druid")} stroke-width="6.1" />
            </pattern>
            <pattern id="dr_js" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(-45)">
                <line x1="0" y="0" x2="0" y2="6" stroke={lc("js")} stroke-width="6" />
                <line x1="6" y="0" x2="6" y2="6" stroke={lc("druid")} stroke-width="6.1" />
            </pattern>
            <pattern id="sk_js" patternUnits="userSpaceOnUse" width="6" height="6" patternTransform="rotate(-45)">
                <line x1="0" y="0" x2="0" y2="6" stroke={lc("js")} stroke-width="6" />
                <line x1="6" y="0" x2="6" y2="6" stroke={lc("sklearn")} stroke-width="6.1" />
            </pattern>
        </defs>
        <text x={margin.left} y={28} text-anchor="start" dominant-baseline="central" font-size="1.3em">{d.key}</text>
        <g transform="translate({margin.left + 31 * (W + wm)}, {15})">
            {#each d3.range(steps) as t}
                <g transform="translate({-(steps-t) * (W + wm)}, 0)">
                    <rect
                        width={W}
                        height={W}
                        fill={c(100 + (C.domain()[1] - 100) / steps * t)}>
                    </rect>
                    <g transform="translate({W/2}, {W/2}) rotate(45)">
                        <text style="pointer-events: none;"
                            text-anchor="middle"
                            dominant-baseline="central"
                            font-family="Courier Prime"
                            font-size="0.6em"
                            font-weight=800
                            fill={(100 + (C.domain()[1] -100) / steps * t) > lim ? "white" : "#333"}>
                            {d3.format(".0f")(100 + (C.domain()[1] -100) / steps * t)}</text>
                    </g>
                </g>
            {/each}
                <g transform="translate({-(steps+1) * (W + wm)}, 0)">
                    <rect
                        width={W}
                        height={W}
                        fill={c(0)}>
                    </rect>
                    <g transform="translate({W/2}, {W/2}) rotate(45)">
                        <text style="pointer-events: none;"
                            text-anchor="middle"
                            dominant-baseline="central"
                            font-family="Courier Prime"
                            font-size="0.6em"
                            font-weight=800
                            fill="white">
                            &leq;100</text>
                    </g>
                </g>
                <g transform="translate({-(steps+1) * (W + wm) - 5}, {W/2})">
                    <text text-anchor="end" dominant-baseline="middle" font-size=20 font-family="Courier Prime">t/ms:</text>
                </g>
        </g>
        <!-- Comp -->
        <g transform="translate({margin.left}, {margin.top2})">

        <g transform="translate({-15}, {25}) rotate(-90)">
            <line x1={-20} x2={-10} stroke="black"></line>
            <line x1={10} x2={20} stroke="black" marker-end="url(#arrow)"></line>
            <text text-anchor="middle" dominant-baseline="middle" font-size=20 font-family="Courier Prime">D</text>
        </g>
            {#each d3.range(8) as i}
                {#each d3.range(31) as j} 
                    <rect
                        x={j * (W + wm)}
                        y={(7-i) * (ch)}
                        width={W}
                        height={ch}
                        fill={lc(winner(d.values.find(d => d.LIB == "druid"), d.values.find(d => d.LIB == "sklearn"), d.values.find(d => d.LIB == "js"), i, j))}>
                    </rect>
                {/each}
            {/each}
        </g>
        <!-- Eval -->
        {#each d.values as librow, k}
            <g transform="translate({margin.left}, {margin.top + k * (H+m)})">
                <g transform="translate(-60, {(9 * (h + hm)) /2}) rotate(-90)">
                    <text text-anchor="end" dominant-baseline="central" font-size="1.3em" font-family="Courier Prime">{librow.LIB}</text>
                    <circle cx=15 r=10 fill={lc(librow.LIB)}></circle>
                </g>
                {#each librow as row, l}
                    <g transform="translate(-5, {(8 - l) * (h + hm) + h / 2})">
                        <text dominant-baseline="central" text-anchor="end" font-family="Courier Prime">{Math.floor(2 * 5 ** ((l + 1) / 2))}</text>
                    </g>
                    {#each d3.range(31).map(y => row[y] || 0) as col, j}
                        <rect class:data={!computing}
                            width={W}
                            height={h}
                            x={j * (W + wm)}
                            y={(8 - l) * (h+hm)}
                            fill={col ? c(d3.mean(col.dur, d => d[2] - d[0])) : "url(#none)"}
                            on:click={dispatch("select", {
                                    "d": col.d,
                                    "n": col.n,
                                    "dr": librow.DR,
                                })}
                        >
                            <title>{col ? d3.format(".2f")(d3.mean(col.dur, d => d[2] - d[0])) + "ms" : ""}</title>
                        </rect>
                        {#if col && d3.mean(col.dur, d => d[2] - d[0]) < 10000 }
                            <g transform="translate({j * (W + wm) + W/2}, {(8 - l) * (h+hm) + h/2}) rotate(45) scale(1, 1)">
                            <text style="pointer-events: none;"
                                text-anchor="middle"
                                dominant-baseline="central"
                                font-family="Courier Prime"
                                font-size="0.6em"
                                font-weight=800
                                fill={((d3.mean(col.dur, d => d[2] - d[0])) > lim || (d3.mean(col.dur, d => d[2] - d[0])) < 100) ? "white" : "#333"}
                                >
                                {d3.format(".0f")(d3.mean(col.dur, d => d[2] - d[0]))}
                            </text>
                            </g>
                        {/if}
                    {/each}
                {/each}
            </g>
        {/each}
        <g transform="translate({margin.left}, {margin.top + d.values.length * (H + m)})">
            {#each d3.range(31).map(j => d.values[0][0][j] || {n: Math.floor(16 + 2 ** ((j+1)/2 + 1))}) as col, j}
                <g transform="translate({(j * (W+wm) + W/2)}, 5) rotate(60)">
                    <text dominant-baseline="central" font-family="Courier Prime">{col.n}</text>
                </g>
            {/each}
        </g>
        <g transform="translate({margin.left - 35}, {margin.top + d.values.length * (H + m) - 20}) rotate(-90)">
            <line x1={-30} x2={-10} stroke="black"></line>
            <line x1={10} x2={30} stroke="black" marker-end="url(#arrow)"></line>
            <text text-anchor="middle" dominant-baseline="middle" font-size=20 font-family="Courier Prime">D</text>
        </g>


        <g transform="translate({margin.left + 20}, {margin.top + d.values.length * (H + m) + 35})">
            <line x1={-30} x2={-10} stroke="black"></line>
            <line x1={10} x2={30} stroke="black" marker-end="url(#arrow)"></line>
            <text text-anchor="middle" dominant-baseline="middle" font-size=20 font-family="Courier Prime">N</text>
        </g>

        
    </svg>
    <br>
{/each}

<style>
    rect.data:hover {
        stroke: black;
        stroke-width: 2px;
    }

    rect.data:active {
        stroke: blue;
        stroke-width: 4px;
    }

    rect.data:active +g {
        font-size: 2em;
    }
    rect {
        transition: stroke 300ms ease-in-out;
        transition: stroke-width .30s ease-in-out;
    }

    text {
        transition: font-size 300ms ease-in-out;
    }
</style>